const colourKey = (value) => String(value || '').normalize('NFKC').trim().toLocaleLowerCase().replace(/\s+/g, ' ');
class KeshRugColourCard extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    this.buttons = [...this.querySelectorAll('[data-image-index]')];
    this.images = [...this.querySelectorAll('[data-colour-image]')];
    this.productLinks = [...this.querySelectorAll('.kr-product-card__main')];
    this.colours = JSON.parse(this.querySelector('[data-card-colours]')?.textContent || '[]');
    this.buttons.forEach((button) => button.addEventListener('click', () => this.select(Number(button.dataset.imageIndex)), {signal:this.abort.signal}));
  }
  disconnectedCallback() { this.abort?.abort(); }
  select(index, notify = true) {
    const selectedButton = this.buttons.find(button => Number(button.dataset.imageIndex) === index);
    if (!selectedButton) return;
    this.images.forEach((image, imageIndex) => {
      const active = Number(image.dataset.imagePosition ?? imageIndex) === index;
      image.classList.toggle('is-active', active);
      if (this.hasAttribute('data-collection-palette-card')) image.hidden = !active;
    });
    this.buttons.forEach(button => {
      const active = button === selectedButton;
      button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active));
    });
    const colour = this.colours.find(item => item.index === index);
    const variantUrl = colour?.url || selectedButton.dataset.variantUrl;
    if (variantUrl) this.productLinks.forEach(link => link.setAttribute('href', variantUrl));
    if (colour) {
      this.selectedColour = colour.name;
      const price = this.querySelector('.kr-product-card__price');
      if (price) price.textContent = colour.available ? `from ${colour.price}` : 'Sold out in this colour';
      this.setStatus(!colour.image ? `${colour.name} — image coming soon` : !colour.available ? `${colour.name} — sold out` : '');
      this.toggleAttribute('data-colour-image-missing', !colour.image);
      if (!colour.image) this.images.forEach(image => image.hidden = true);
    }
    if (notify) this.dispatchEvent(new CustomEvent('kr:card-colour', {bubbles:true, detail:{name:colour?.name || selectedButton.dataset.colourName}}));
  }
  selectColour(name) {
    const colour = this.colours.find(item => colourKey(item.name) === colourKey(name));
    // A collection palette changes matching rugs only; preserve every other card.
    if (!colour) return false;
    this.select(colour.index, false); return true;
  }
  setStatus(message) {
    this.removeAttribute('data-colour-unavailable');
    const status=this.querySelector('[data-colour-status]');
    if(status){status.textContent=message;status.hidden=!message;}
  }
}
if (!customElements.get('kr-colour-card')) customElements.define('kr-colour-card', KeshRugColourCard);
